import React, { useState } from 'react';
import VariantPickerDropdown from '../VariantPicker/VariantPicker.Dropdown';
import BuyButton from '../BuyButton/BuyButton';
import { translate } from '../../Services/translation';
import Product from '../../Types/Product';
import { VariantPickerMultiVariantOption } from '../VariantPicker/types/VariantPicker.Inteface';

const ProductCardVariantPicker = ({
  product,
  className,
}: {
  product: Product;
  className: string;
}) => {
  const [
    selectedVariant,
    setSelectedVariant,
  ] = useState<VariantPickerMultiVariantOption>();

  const onChange = (event) => {
    setSelectedVariant(event);
  };

  return (
    <div className={className}>
      <VariantPickerDropdown
        {...product.variantPickerOptions}
        setSelectedArticleNumber={onChange}
        selectedVariant={selectedVariant}
        menuPlacement="top"
      />
      <BuyButton
        disabled={
          !selectedVariant ||
          !selectedVariant.inStock ||
          selectedVariant.disabled
        }
        articleNumber={selectedVariant?.variantId}
        label={translate('general.buy')}
      />
    </div>
  );
};

export default ProductCardVariantPicker;
